(function ($) {
    $.fn.scrollElementIntoViewport = function (options) {
        var defaults = {
            target: null
        },
        settings = $.extend(defaults, options);

        if(!settings.target) {
            throw new ReferenceError('Cannot find target "' + settings.target + '"');
        }

        var target = settings.target,
            $el = $(target),
            $elementIndex = $el.data('index'),
            $elementHeight = $el.height(),
            $viewport = $(this),
            $viewportHeight = $viewport.height(),
            isInsideViewport = isInView(),
            direction, scrollAmount;

        if(!isInsideViewport) {
            direction = scrollDirection();

            switch(direction) {
                case 'top':
                    scrollAmount = $elementIndex * $elementHeight;
                    break;
                case 'bottom':
                    scrollAmount = $elementIndex * $elementHeight - $viewportHeight + $elementHeight;
                    break;
                default:
                    break;
            }

            $viewport.scrollTop(scrollAmount);
        }

        /**
         * Checks if element is inside viewport
         *
         * @returns {Boolean}
         */
        function isInView() {
            var $elemTopPosition = $el.position().top - $viewport.position().top,
                $elemBottomPosition = $elemTopPosition + $el.height();

            return ($elemTopPosition > 0) && ($elemBottomPosition < $viewportHeight);
        }

        function scrollDirection() {
            var $elemTopPosition = $el.position().top - $viewport.position().top,
                $elemBottomPosition = $elemTopPosition + $el.height(),
                direction = null;

            if ($elemTopPosition <= 0) {
                direction = 'top';
            } else if ($elemBottomPosition >= $viewportHeight) {
                direction = 'bottom';
            }

            return direction;
        }
    };
})(jQuery);